import React from "react";
import { Code2, ShieldCheck, Clock, Cloud, Database, Wrench } from "lucide-react";

const features = [
  { icon: Code2, title: "Clean & Scalable Code", text: "Maintainable architecture that supports future growth without frequent rework.", color: "from-blue-500 to-cyan-400" },
  { icon: ShieldCheck, title: "Security-First Development", text: "Secure APIs, authentication best practices, and data protection across the stack.", color: "from-violet-500 to-fuchsia-400" },
  { icon: Clock, title: "On-Time Delivery", text: "Milestone-based planning with clear timelines and regular progress updates.", color: "from-amber-500 to-orange-400" },
  { icon: Cloud, title: "Deployment & Hosting", text: "Domain / DNS / SSL setup, server deployment, cloud hosting and production support.", color: "from-sky-500 to-blue-400" },
  { icon: Database, title: "Database Expertise", text: "SQL Server, PostgreSQL, Firebase (Firestore / Realtime) design & optimization.", color: "from-emerald-500 to-teal-400" },
  { icon: Wrench, title: "Support & Maintenance", text: "Post-launch support, bug fixes, enhancements, and performance tuning.", color: "from-rose-500 to-pink-400" },
];

export const Features = () => {
  return (
    <section id="features" className="relative bg-[#05070f] py-24 overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[420px] h-[420px] rounded-full bg-blue-700/10 blur-[120px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="eyebrow reveal">Why Sudeeshaa</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            Built for <span className="text-gradient">reliability</span> &amp; growth
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
            Modern engineering practices, honest communication, and support that
            lasts well beyond launch.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className={`reveal d${(i % 3) + 1} glow-card group rounded-3xl p-8 glass hover:bg-white/[0.06] hover:-translate-y-1.5 transition-all duration-300`}
              >
                <div className={`h-14 w-14 rounded-2xl bg-gradient-to-br ${f.color} grid place-items-center mb-6 shadow-lg group-hover:scale-110 transition`}>
                  <Icon className="h-7 w-7 text-white" strokeWidth={2.4} />
                </div>
                <h3 className="text-lg font-extrabold text-white">{f.title}</h3>
                <p className="mt-3 text-slate-400 leading-relaxed">{f.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
